import { apiClient } from './api';
import type { SonIslemZamaniListResult } from '../types/eStatement';

export interface SonIslemZamaniBankChartData {
  bankaKodu: number;
  bankaAdi: string;
  basarili: number;
  basarisiz: number;
  toplam: number;
}

export interface SonIslemZamaniChartResult {
  bankChartData: SonIslemZamaniBankChartData[];
}

export const eStatementService = {
  /**
   * Son işlem zamanı listesini getir (serverside paging ile)
   */
  getSonIslemZamaniList: async (params?: {
    tenantId?: string;
    serverId?: string;
    vkn?: string;
    uid?: string;
    bankaKodu?: number;
    erpSirketKodu?: string;
    durum?: boolean;
    page?: number;
    pageSize?: number;
  }): Promise<SonIslemZamaniListResult> => {
    const queryParams = new URLSearchParams();
    
    if (params?.tenantId) queryParams.append('tenantId', params.tenantId);
    if (params?.serverId) queryParams.append('serverId', params.serverId);
    if (params?.vkn) queryParams.append('vkn', params.vkn);
    if (params?.uid) queryParams.append('uid', params.uid);
    if (params?.bankaKodu !== undefined) queryParams.append('bankaKodu', params.bankaKodu.toString());
    if (params?.erpSirketKodu) queryParams.append('erpSirketKodu', params.erpSirketKodu);
    if (params?.durum !== undefined) queryParams.append('durum', params.durum.toString());
    queryParams.append('page', (params?.page || 1).toString());
    queryParams.append('pageSize', (params?.pageSize || 20).toString());

    const response = await apiClient.get<SonIslemZamaniListResult>(
      `/EStatement/son-islem-zamani?${queryParams.toString()}`
    );
    return response.data;
  },

  /**
   * eStatement chart verilerini getir
   */
  getChart: async (
    tenantId?: string,
    serverId?: string
  ): Promise<SonIslemZamaniChartResult> => {
    const params = new URLSearchParams();
    if (tenantId) params.append('tenantId', tenantId);
    if (serverId) params.append('serverId', serverId);

    const response = await apiClient.get<SonIslemZamaniChartResult>(
      `/EStatement/son-islem-zamani/chart?${params.toString()}`
    );
    return response.data;
  },
};
